module.exports = __webpack_public_path__ + "static/media/logo-ISO.516dac5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-ISO.png
// module id = 121
// module chunks = 0